import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import axios from "axios";
import { BASE_URL } from "../Component/Baseurl";
import Footer from "../Component/Footer";
import defaultImage from "../Component/img/event1.jfif";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';

const News = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axios.get(`${BASE_URL}getAllArticles`);
        console.log("API Response:", response);

        if (response.data.success && response.data.articles) {
          setArticles(response.data.articles);
        } else {
          setError("Failed to fetch articles");
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching articles:", error);
        setError("Error fetching articles");
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <span className="loader"></span>
        <p className="ms-3">Loading Articles...</p>
      </div>
    );
  }

  if (error) return <p className="text-center text-danger">{error}</p>;

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://evventoz.com/news" />
        <title>Latest Articles</title>
      </Helmet>

      <NavbarVisitor />

      <div className="container mt-3">
        <h2 className="mb-4">Latest Articles</h2>

        <div className="row g-4 mb-5">
          {articles.map((article) => (
            <div key={article.id} className="col-md-4 col-sm-6">
              <Link to={`/article/${article.slug}`} className="text-decoration-none text-dark">
                <div className="card h-100 shadow-sm">
                  <img
                    src={article.featured_image || defaultImage}
                    className="card-img-top"
                    alt={article.title}
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{article.title}</h5>
                    <p className="card-text small text-muted mb-1">
                      <strong>By:</strong> {article.author_name || "Unknown"}<br />
                      <strong>Updated:</strong>{" "}
                      {new Date(article.updated_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </p>
                    <p className="card-text">{article.summary}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default News;
